export default "__VITE_ASSET__77cxSHH$__"